export default "__VITE_ASSET__CNU6ac_W__"